import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 8.5C10.7761 8.5 11 8.72386 11 9C11 9.27614 10.7761 9.5 10.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9C1 8.72386 1.22386 8.5 1.5 8.5H10.5ZM10.5 5.5C10.7761 5.5 11 5.72386 11 6C11 6.27614 10.7761 6.5 10.5 6.5H1.5C1.22386 6.5 1 6.27614 1 6C1 5.72386 1.22386 5.5 1.5 5.5H10.5ZM10.5 2.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.9999 11.333C14.3681 11.333 14.6666 11.6315 14.6666 11.9997C14.6666 12.3679 14.3681 12.6663 13.9999 12.6663H1.99992C1.63173 12.6663 1.33325 12.3679 1.33325 11.9997C1.33325 11.6315 1.63173 11.333 1.99992 11.333H13.9999ZM13.9999 7.33301C14.3681 7.33301 14.6666 7.63148 14.6666 7.99967C14.6666 8.36786 14.3681 8.66634 13.9999 8.66634H1.99992C1.63173 8.66634 1.33325 8.36786 1.33325 7.99967C1.33325 7.63148 1.63173 7.33301 1.99992 7.33301H13.9999ZM13.9999 3.33301C14.3681 3.33301 14.6666 3.63148 14.6666 3.99967C14.6666 4.36786 14.3681 4.66634 13.9999 4.66634H1.99992C1.63173 4.66634 1.33325 4.36786 1.33325 3.99967C1.33325 3.63148 1.63173 3.33301 1.99992 3.33301H13.9999Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5001 14.167C17.9603 14.167 18.3334 14.5401 18.3334 15.0003C18.3334 15.4606 17.9603 15.8337 17.5001 15.8337H2.50008C2.03984 15.8337 1.66675 15.4606 1.66675 15.0003C1.66675 14.5401 2.03984 14.167 2.50008 14.167H17.5001ZM17.5001 9.16699C17.9603 9.16699 18.3334 9.54009 18.3334 10.0003C18.3334 10.4606 17.9603 10.8337 17.5001 10.8337H2.50008C2.03984 10.8337 1.66675 10.4606 1.66675 10.0003C1.66675 9.54009 2.03984 9.16699 2.50008 9.16699H17.5001ZM17.5001 4.16699C17.9603 4.16699 18.3334 4.54009 18.3334 5.00033C18.3334 5.46056 17.9603 5.83366 17.5001 5.83366H2.50008C2.03984 5.83366 1.66675 5.46056 1.66675 5.00033C1.66675 4.54009 2.03984 4.16699 2.50008 4.16699H17.5001Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 6C1 5.72386 1.22386 5.5 1.5 5.5H10.5C10.7761 5.5 11 5.72386 11 6C11 6.27614 10.7761 6.5 10.5 6.5H1.5C1.22386 6.5 1 6.27614 1 6Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1 9C1 8.72386 1.22386 8.5 1.5 8.5H10.5C10.7761 8.5 11 8.72386 11 9C11 9.27614 10.7761 9.5 10.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1.33325 7.99967C1.33325 7.63148 1.63173 7.33301 1.99992 7.33301H13.9999C14.3681 7.33301 14.6666 7.63148 14.6666 7.99967C14.6666 8.36786 14.3681 8.66634 13.9999 8.66634H1.99992C1.63173 8.66634 1.33325 8.36786 1.33325 7.99967Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1.33325 3.99967C1.33325 3.63148 1.63173 3.33301 1.99992 3.33301H13.9999C14.3681 3.33301 14.6666 3.63148 14.6666 3.99967C14.6666 4.36786 14.3681 4.66634 13.9999 4.66634H1.99992C1.63173 4.66634 1.33325 4.36786 1.33325 3.99967Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1.33325 11.9997C1.33325 11.6315 1.63173 11.333 1.99992 11.333H13.9999C14.3681 11.333 14.6666 11.6315 14.6666 11.9997C14.6666 12.3679 14.3681 12.6663 13.9999 12.6663H1.99992C1.63173 12.6663 1.33325 12.3679 1.33325 11.9997Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1.66675 10.0003C1.66675 9.54009 2.03984 9.16699 2.50008 9.16699H17.5001C17.9603 9.16699 18.3334 9.54009 18.3334 10.0003C18.3334 10.4606 17.9603 10.8337 17.5001 10.8337H2.50008C2.03984 10.8337 1.66675 10.4606 1.66675 10.0003Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1.66675 5.00033C1.66675 4.54009 2.03984 4.16699 2.50008 4.16699H17.5001C17.9603 4.16699 18.3334 4.54009 18.3334 5.00033C18.3334 5.46056 17.9603 5.83366 17.5001 5.83366H2.50008C2.03984 5.83366 1.66675 5.46056 1.66675 5.00033Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1.66675 15.0003C1.66675 14.5401 2.03984 14.167 2.50008 14.167H17.5001C17.9603 14.167 18.3334 14.5401 18.3334 15.0003C18.3334 15.4606 17.9603 15.8337 17.5001 15.8337H2.50008C2.03984 15.8337 1.66675 15.4606 1.66675 15.0003Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconMenu01: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"menu-01"} {...props} />
);
